import {
  TypeOfferCardWithoutUnresolvableLinksResponse,
  TypeOffersFilterWithoutUnresolvableLinksResponse,
} from 'contentful-types'

import { withContentful } from 'src/siteBuilder/renderer/contentful/withContentful'

import OffersFilter, { OffersFilterProps } from './OffersFilter'
import { mapTags, ContentfulITag } from 'src/siteBuilder/renderer/contentful/mapTags'
import { BlockRenderer } from 'src/siteBuilder/renderer/contentful/BlockRenderer'

const ContentfulOffersFilter = withContentful<
  TypeOffersFilterWithoutUnresolvableLinksResponse['fields'],
  OffersFilterProps
>(OffersFilter, {
  sysID: (props) => props.sys.id,
  filterTags: (props) => mapTags(props.fields.filterTags as unknown as ContentfulITag[]),
  offerCards: (props) =>
    props.fields.offerCards.map((card) => {
      const {
        tags,
        img,
        background,
        anchorID,
        fullWidth,
        ribbon,
        campaignBadge,
        heading,
        content,
        cta,
        ctaSecondary,
        cardTag,
      } = card.fields as TypeOfferCardWithoutUnresolvableLinksResponse['fields']

      return {
        id: props.sys.id,
        tags: mapTags(tags as unknown as ContentfulITag[]),
        img: !!img
          ? {
              src: img.fields?.file?.url,
              width: img.fields?.file?.details.image.width,
              height: img.fields?.file?.details.image.height,
              alt: img.fields?.description,
            }
          : undefined,
        background: background?.toLocaleLowerCase() as Lowercase<typeof background>,
        anchorID,
        fullWidth,
        ribbon,
        campaignBadge,
        cardTag: cardTag,
        heading: (
          <BlockRenderer
            block={{
              ...heading,
              fields: {
                ...heading.fields,
                size: 'H3',
                heading: 'H3',
                colour: 'Secondary',
              },
            }}
            fieldPath={'.heading'}
          />
        ),
        content: <BlockRenderer block={content} fieldPath={'.content'} />,
        cta: !!cta && (
          <BlockRenderer
            block={{
              ...cta,
              fields: {
                text: cta.fields?.text,
                url: cta.fields?.url,
                width: cta.fields?.width,
              },
            }}
            fieldPath={'.cta'}
          />
        ),
        ctaSecondary: !!ctaSecondary && (
          <BlockRenderer
            block={{
              ...ctaSecondary,
              fields: {
                text: ctaSecondary.fields?.text,
                url: ctaSecondary.fields?.url,
              },
            }}
            fieldPath={'.ctaSecondary'}
          />
        ),
      }
    }),
})

export default ContentfulOffersFilter
